module.exports = __webpack_public_path__ + "static/pattern-2ecaa82d40581131bd72b46fa484cf27.png";